import { render, staticRenderFns } from "./TravelPackageHistory.vue?vue&type=template&id=46dcf3f6&scoped=true"
import script from "./TravelPackageHistory.vue?vue&type=script&lang=js"
export * from "./TravelPackageHistory.vue?vue&type=script&lang=js"
import style0 from "./TravelPackageHistory.vue?vue&type=style&index=0&id=46dcf3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dcf3f6",
  null
  
)

export default component.exports